import React, { ReactNode } from "react";
import clsx from "clsx";

import Button, { ButtonProps } from "../Button/Button";

export interface IconButtonProps extends ButtonProps {
	description?: ReactNode;
}

const IconButton = (props: IconButtonProps) => {
	const { children, className, description, ...otherProps } = props;

	return (
		<Button className={clsx("IconButton", className)} {...otherProps}>
			{children}
			{description && (
				<div className={"IconButton__description"}>{description}</div>
			)}
		</Button>
	);
};

export default IconButton;
